import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Footer } from "@core/components/shared/Footer";

const LINKS = [
  { to: "/vs/doodle", key: "polls:landing.footer.vs_doodle" },
  { to: "/vs/framadate", key: "polls:landing.footer.vs_framadate" },
  { to: "/ai", key: "polls:landing.footer.ai" },
] as const;

/**
 * Liens « Découvrir » (comparatifs, page IA) : maillage interne des pages
 * publiques pré-rendues, pour les moteurs et les IA qui les explorent.
 */
export function DiscoverLinks() {
  const { t } = useTranslation("polls");
  return (
    <nav
      data-testid="footer-discover"
      className="flex flex-wrap justify-center items-center gap-4 text-xs"
    >
      {LINKS.map((l, i) => (
        <React.Fragment key={l.to}>
          {i > 0 && <span className="text-muted-foreground">·</span>}
          <Link
            to={l.to}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            {t(l.key)}
          </Link>
        </React.Fragment>
      ))}
    </nav>
  );
}

/** Pied de page des pages publiques : liens « Découvrir » + pied commun. */
export function PublicFooter() {
  return (
    <div className="mt-12">
      <DiscoverLinks />
      <Footer />
    </div>
  );
}
